export default {
  breadcrumb: {
    settlements: "Settlements  >",
    settlementId: "Settlement {id}"
  },
  title: "Settlement",
  createdAt: "Settlement created at",
  totalAmount: "Total amount",
  sponsor: "Sponsor: ",
  loadingDataLabel: "Loading claims",
  emptyDataLabel: "No results found",
  resultLabel: "{result} Claims",
   NoResults: "No claims found",
  grid: {
    authorizationId: "Claim ID",
    createdAt: "Created At",
    beneficiary: "Beneficiary",
    memberCode: "Member Code",
    branch: "Branch",
    amount: "Amount"
  },
  filters: {
    searchCode: "Search by claim ID"
  }
}
